import { plural } from './plural'

/** Strings for the skills page (S7). */
export const skillsCopy = {
  page: {
    crumb: 'Skills',
    title: 'Skills',
    description: 'Custom procedures and agent capabilities',
    workspaceFallback: 'Workspace',
  },
  loadFailed: 'Could not load skills.',
  loadSkillFailed: 'Could not load this skill.',
  refreshFailed: 'Could not refresh skills.',
  refreshSkillFailed: 'Could not refresh this skill.',
  retry: 'Retry',
  toggleName: (open: boolean, name: string) =>
    `${open ? 'Close' : 'Open'} ${name}`,
  deleteFileName: (path: string) => `Delete ${path}`,
  toast: {
    created: 'Skill created',
    createFailed: 'Failed to create skill — try again.',
    saved: 'Skill saved',
    saveFailed: 'Failed to save skill — try again.',
    deleted: 'Skill deleted',
    deleteFailed: 'Failed to delete skill — try again.',
    restored: 'Skill restored',
    restoreFailed: 'Failed to restore skill — try again.',
    fileDeleted: 'File deleted',
    fileDeleteFailed: 'Failed to delete file — try again.',
  },
  tabs: {
    label: 'Skill status',
    active: 'Active',
    archived: 'Archived',
  },
  empty: {
    active: 'No skills yet.',
    archived: 'No archived skills.',
  },
  glyph: {
    builtin: 'Built-in skill',
    agent: 'Written by an agent',
    person: 'Written by a person',
  },
  builtinChip: 'Built-in',
  noDescription: 'No description',
  meta: ({
    builtin,
    uses,
    lastRead,
    tags,
  }: {
    builtin: boolean
    uses: number
    lastRead: string | null
    tags: string[]
  }) => {
    const parts = builtin
      ? []
      : [
          plural(uses, { one: '{n} view', other: '{n} views' }),
          lastRead ? `last read ${lastRead}` : 'never read',
        ]
    if (tags.length > 0) parts.push(tags.join(', '))
    return parts.join(' · ')
  },
  actions: {
    restore: 'Restore',
    open: 'Open',
    close: 'Close',
    newSkill: 'New skill',
    create: 'Create',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    deleteSkill: 'Delete skill',
  },
  create: {
    nameLabel: 'Name',
    namePlaceholder: 'deploy-nixos',
    descriptionLabel: 'Description',
  },
  editor: {
    meta: ({
      builtin,
      version,
      author,
      updated,
    }: {
      builtin: boolean
      version: string
      author: string
      updated: string
    }) =>
      builtin
        ? 'built-in · read-only'
        : `v${version} · by ${author} · updated ${updated}`,
    description: 'Description',
    tags: 'Tags (comma-separated)',
    content: 'Content (Markdown)',
    supportingFiles: 'Supporting files',
    bytes: (n: number) => `${n} bytes`,
    builtinNotice:
      'Built-in skills cannot be edited — create a workspace skill under another name.',
  },
  confirm: {
    skillTitle: 'Delete skill',
    skillDescription: (name: string) =>
      `Permanently deletes "${name}" and its files.`,
    fileTitle: 'Delete file',
    fileDescription: (path: string) => `Permanently deletes "${path}".`,
    confirm: 'Delete',
  },
} as const
